import { render, staticRenderFns } from "./SliderFull.vue?vue&type=template&id=5fb7c0be&scoped=true"
import script from "./SliderFull.vue?vue&type=script&lang=js"
export * from "./SliderFull.vue?vue&type=script&lang=js"
import style0 from "./SliderFull.vue?vue&type=style&index=0&id=5fb7c0be&prod&lang=css"
import style1 from "./SliderFull.vue?vue&type=style&index=1&id=5fb7c0be&prod&lang=scss&scoped=true"
import style2 from "./SliderFull.vue?vue&type=style&index=2&id=5fb7c0be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb7c0be",
  null
  
)

export default component.exports